// 用途: APIが503を返した際にメンテナンス状態を更新し、/maintenance へ遷移させるインターセプタ
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { MaintenanceStateService } from '@app/shared/services/maintenance-state.service';
import { catchError, throwError } from 'rxjs';

export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const state = inject(MaintenanceStateService);
  const router = inject(Router);
  const zone = inject(NgZone);

  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 503) {
        // 状態を更新
        state.setFromHttpError(error);

        // すでにメンテページなら遷移しない
        const currentUrl = router.url || '';
        if (!currentUrl.startsWith('/maintenance')) {
          // ゾーン内で遷移（NavigationTriggeredOutsideAngular回避）
          zone.run(() => {
            void router.navigateByUrl('/maintenance');
          });
        }
      }
      return throwError(() => error);
    })
  );
};
